"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/AlertsScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _hooks = require('web/services/hooks');
var _AlertComponent = require('web/components/AlertComponent'); var _AlertComponent2 = _interopRequireDefault(_AlertComponent);

const onClose = () => {
  _actions2.default.clearAlerts()
}

// memo keeps connect()'s bailout on parent re-renders.
const AlertsScreen = _react.memo.call(void 0, function AlertsScreen () {
  const alerts = _hooks.useAppSelector.call(void 0, state => state.alerts)

  const alert = alerts[0]
  if (!alert) {
    return null
  }

  return (
    _react2.default.createElement(_AlertComponent2.default, {
      key: alert.key,
      title: alert.title,
      body: alert.body,
      type: alert.type,
      onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}})
  )
})

exports. default = AlertsScreen
